
import Header from '../../components/feature/Header';
import MembersHero from './components/MembersHero';
import PartnersSection from './components/PartnersSection';
import MembersCTA from './components/MembersCTA';

export default function MembersPage() {
  return (
    <div className="min-h-screen">
      <Header />
      <MembersHero />
      <PartnersSection />
      <MembersCTA />
    </div>
  );
}
